import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.007 26.964a1 1 0 0 0 .999 1.001 190983.316 190983.316 0 0 1 21.937.014 1 1 0 0 0 .684-1.73l-10.618-9.94a1.5 1.5 0 0 0-2.049-.002l-10.636 9.927a1 1 0 0 0-.317.73Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Arrow-Up_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 13,
    width: 28,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.375 14.849a3.5 3.5 0 0 0-4.78-.004L10.96 24.772a3 3 0 0 0 2.045 5.193 190978.128 190978.128 0 0 1 21.937.014 3 3 0 0 0 2.052-5.19l-10.619-9.94ZM13.006 27.965a1 1 0 0 1-.682-1.731l10.636-9.927a1.5 1.5 0 0 1 2.049.002l10.618 9.94a1 1 0 0 1-.684 1.73 218774.52 218774.52 0 0 1-21.937-.014Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Arrow-Up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  })));
};

var SvgArrowUp = styled(SvgComponent).withConfig({
  displayName: "ArrowUp__SvgArrowUp",
  componentId: "sc-wcefva-0"
})(["", " ", ""], size, color);
export default SvgArrowUp;